import {Component, OnInit} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {OtpScreen} from '../otp';
import {OtpSendComponent} from '../send/send.component';

@Component({
  selector: 'otp-resend',
  templateUrl: './resend.component.html',
  styleUrls: ['resend.component.scss'],
})
export class OtpResendComponent extends OtpSendComponent implements OnInit {

  ngOnInit() {
    let defaultContact = this.otpService.selectedRecipient
      ? this.otpService.selectedRecipient.contactId
      : this.commonDataService.user.billingAccountId;
    this.otpSendForm = this.fb.group({
      contactId: new FormControl(defaultContact, Validators.required)
    });
  }

  public back(): void {
    this.otpService.currentScreen = OtpScreen.SEND;
  }

}
